module.exports = __webpack_public_path__ + "static/media/review.a07f4e41.svg";